import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Helpers
import { confirm, toggleDrawer } from '../../helpers/helpers.js';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';
import Delayed from 'react-delayed';

// Components
import * as icons from '../Icons/Icons';
import Drawer from '../Drawer/Drawer';
import Toolbar from '../Common/Toolbar';

const CourseOfferings = observer(class CourseOfferings extends React.Component {
  constructor() {
    super();
    this.getCourseOfferings = this.getCourseOfferings.bind(this);
    this.addCourseOffering = this.addCourseOffering.bind(this);
    this.deleteOfferings = this.deleteOfferings.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentWillMount() {
    this.state = {
      drawerOpen: false,
      drawerContent: null,
      offeringSid: null,
      fundingRuleSid: null,
      selectedRows: []
    };

    this.getCourseOfferings()
  }

  componentDidMount() {
    const { pathname } = this.props.routing.location;
    const { SessionStore } = this.props.store;

    if(pathname.indexOf('edit') > -1 || pathname.indexOf('add') > -1) {
      SessionStore.loading = false;
      toggleDrawer(null, this, 'EditCourseOffering');
    }

    if(pathname.indexOf('edit') > -1) {
      const userSid = pathname.substr(pathname.lastIndexOf('/') + 1);

      this.setState({
        userSid
      });
    }
  }

  getCourseOfferings(reload) {
    if(this.props.store.CourseStore.courseOfferings.length === 0 || reload) {
      this.props.store.CourseStore.getCourseOfferings();
    }
  }

  addCourseOffering() {
    this.props.store.CourseStore.offering = {};

    this.setState({
      drawerOpen: true,
      drawerContent: 'EditCourseOffering'
    })
  }

  handleEdit(e, offeringSid) {
    e.preventDefault();

    // Update url
    let path = e.target.href.replace(/^(?:\/\/|[^\/]+)*\//, '').replace('#', '');

    if(this.props.routing.location.pathname !== path) {
      this.props.routing.push(path);
    }

    this.setState({
      offeringSid
    });

    toggleDrawer(null, this, 'EditCourseOffering');
  }

  deleteOfferings(offering) {
    const { translation } = this.props;

    let msg = {
      heading: translation.delete_confirm.heading_singular,
      body: translation.delete_confirm.body_singular,
      button: translation.delete_confirm.button
    }

    if(this.state.selectedRows.length > 1) {
      msg.heading = translation.delete_confirm.heading_plural.replace('%count%', this.state.selectedRows.length);
      msg.body = translation.delete_confirm.body_plural;
    }

    let callback = () => this.getCourseOfferings(true);

    // Loop through all the selected funding rules and send delete API request
    const _this = this;

    confirm(
      msg,
      () => {
        for(let i = 0; i < _this.state.selectedRows.length; i++) {
          _this.props.store.CourseStore.deleteCourseOffering(
            _this.state.selectedRows[i],
            callback
          )
        }

        _this.setState({
          selectedRows: []
        });
      }
    );
  }

  manageFundingRule(e, offeringSid) {
    this.setState({
      offeringSid
    });

    toggleDrawer(e, this, 'FundingRules');
  }

  handleSelect(e, sid) {
    let selectedRows = [...this.state.selectedRows];
    let rowIndex = -1;

    if(e.target.checked) {
      selectedRows.push(sid);
    } else {
      rowIndex = selectedRows.indexOf(sid);
      selectedRows.splice(rowIndex, 1);
    }

    this.setState({
      selectedRows
    });
  }

  renderResults() {
    const { CourseStore, SessionStore } = this.props.store;
    const { translation } = this.props;
    const { userTimezone } = this.props.store.SessionStore;

    if(CourseStore.courseOfferings.length > 0) {
      return(
        <table>
          <thead>
            <tr>
              <th id="heading-select" scope="col">
                <span className="meta">Select</span>
              </th>
              <th id="heading-title" className="subtitle" scope="col">
                {translation.title}
              </th>
              <th id="heading-starts" className="subtitle" scope="col">
                {translation.starts}
              </th>
              <th id="heading-ends" className="subtitle" scope="col">
                {translation.ends}
              </th>
              <th id="heading-rules" className="subtitle" scope="col">
                {translation.funding_rules}
              </th>
            </tr>
          </thead>
          <tbody>
            {CourseStore.courseOfferings.map(
              (offering, i) =>
              <tr
                className={
                  this.state.selectedRows.indexOf(offering.sid) >= 0 ? 'selected' : ''
                }
                key={i}
              >
                <td className="check-col" aria-labelledby="heading-select">
                  <input
                    id={`select-${offering.sid}`}
                    className="checkbox-input"
                    type="checkbox"
                    onChange={(e) => this.handleSelect(e, offering.sid)}
                    checked={this.state.selectedRows.indexOf(offering.sid) >= 0}
                  />

                  <label
                    className="checkbox-label checkbox-label--solo"
                    htmlFor={`select-${offering.sid}`}
                  >
                    <span className="meta">Select {offering.title}</span>
                  </label>
                </td>
                <td aria-labelledby="heading-title">
                  <Link
                    to={`/course-offerings/edit/${offering.sid}`}
                    onClick={(e) => {this.handleEdit(e, offering.sid)}}
                    title={`Edit ${offering.title}`}
                  >
                    {offering.title}
                  </Link>
                </td>
                <td aria-labelledby="heading-starts">
                  {moment.utc(offering.startDate).tz(userTimezone).format('M/D/YYYY')}
                </td>
                <td aria-labelledby="heading-ends">
                  {moment.utc(offering.endDate).tz(userTimezone).format('M/D/YYYY')}
                </td>
                <td aria-labelledby="heading-rules">
                  <button
                    className="btn--link"
                    onClick={(e) => {this.manageFundingRule(e, offering.sid)}}
                  >
                    {translation.manage_rules}
                  </button>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )
    } else if(!SessionStore.loading && CourseStore.courseOfferings.length === 0) {
      return (
        <span className="no-results">{translation.no_results}</span>
      )
    }

    return null;
  }

  render() {
    const { translation } = this.props;

    return(
      <main tabIndex="0" id="main-content" className="page">
        <header className="page__header">
          <div className="wrap">
            <h1 className="page__title">{translation.page_title}</h1>

            <button className="btn--outline" onClick={this.addCourseOffering}>
              <icons.iconPlus />
              {translation.create_offering}
            </button>
          </div>
        </header>

        <div className="wrap">
          {this.renderResults()}
        </div>

        <Delayed
          mounted={this.state.selectedRows.length > 0}
          unmountAfter={250}
        >
          <Toolbar
            selectedRows={this.state.selectedRows}
            deleteText={translation.delete}
            deleteFunction={this.deleteOfferings}
            {...this.props}
          />
        </Delayed>

        <Drawer
          content={this.state.drawerContent}
          isOpen={this.state.drawerOpen}
          parent={this}
          getCourseOfferings={this.getCourseOfferings}
          offeringSid={this.state.offeringSid}
          fundingRuleSid={this.state.fundingRuleSid}
          {...this.props}
        />
      </main>
    )
  }
})

export default translate('CourseOfferings')(CourseOfferings);


// WEBPACK FOOTER //
// ./src/app/components/CourseOfferings/CourseOfferings.js